import { ReactNode } from "react";

interface ConditionRendererProps {
  condition: boolean;
  children: ReactNode | [ReactNode, ReactNode?];
}

export const ConditionRenderer = ({
  condition,
  children,
}: ConditionRendererProps) => {
  const [firstChild, secondChild] = Array.isArray(children)
    ? children
    : [children, null];
  return <>{condition ? firstChild : secondChild}</>;
};
